<template>
  <div>
    <form @submit.prevent="createStaff">
      <modal v-show="isStaffModal" @close="closeStaffModal" footer>
        <template v-slot:title>
          <h5>Update Staffs</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="title">First Name</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="staff.first_name"
            />
          </div>
          <div class="form-group">
            <label for="title">Last Name</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="staff.last_name"
            />
          </div>

          <div class="form-group">
            <label for="title">Email</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="staff.email"
            />
          </div>
          <div class="form-group">
            <label for="status">Role</label> <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="staff.role"
            >
              <option value="" disabled>Please Select</option>
              <option v-for="role in roles" :value="role.name" :key="role.id">
                {{ role.name }}</option
              >
            </select>
          </div>
          <div class="form-group">
            <label for="phone_number">Phone Number</label>
            <input
              type="text"
              class="form-control"
              name="phone_number"
              v-model="staff.phone_number"
            />
          </div>

          <!-- <div class="form-group">
            <label for="status">Status</label> <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="staff.status"
            >
              <option value="active" class="mb-2">Active</option>
              <option value="in-active" class="mb-2">
                Inactive
              </option>
            </select>
          </div> -->
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="creatingStaffLoading || !formIsValid"
          >
            <span class="custom-loader" v-if="creatingStaffLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Creating Staff...</span
              >
            </span>
            <span v-else>
              Create Staff
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeStaffModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <loader-ring v-if="getStaffLoading" class="loader-center"></loader-ring>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular fw-bold">Staffs</h1>
        </div>
        <div class="col-auto" v-if="permissions.includes('create-staff')">
          <button
            class="button button--outline text-uppercase"
            @click="showStaffModal"
          >
            Add Staff
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Staffs</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="staffs"
              :fields="fields"
              :items-per-page="100"
              pagination
              sorter
              tableFilter
            >
              <template #updated_at="{item}">
                <td class="table--action-mobile">
                  {{ item.updated_at | date }}
                </td>
              </template>
              <template #action="{item}">
                <td
                  class="table--action-mobile"
                  v-if="permissions.includes('view-staff')"
                >
                  <router-link
                    class="button btn-primary"
                    :to="{ name: 'Staff', params: { slug: item.id } }"
                  >
                    View
                  </router-link>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const fields = [
  "username",
  "first_name",
  "last_name",
  "role",
  "email",
  "profile_status",
  "action"
];
export default {
  name: "staffs",
  components: {
    CDataTable
  },
  data() {
    return {
      currentDate: Date.now(),
      fields,
      small: true,
      roles: [],
      getRolesLoading: false,
      getStaffLoading: false,
      isStaffModal: false,
      creatingStaffLoading: false,
      staffs: [
        {
          id: "1",
          username: "ADM000001",
          role: "Super Admin",
          name: "Olumide Tester",
          email: "admin@apex.com",
          status: "active"
        }
      ],
      staff: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        role: ""
      }
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    formIsValid() {
      return (
        this.staff.first_name !== "" &&
        this.staff.last_name !== "" &&
        this.staff.email !== "" &&
        this.staff.phone_number !== "" &&
        this.staff.role !== ""
      );
    }
  },
  methods: {
    showUpdateModal(item) {
      this.staff = Object.assign({}, item);
      this.showStaffModal();
      console.log(this.staff);
    },
    closeStaffModal() {
      this.isStaffModal = false;
      this.staff = {};
    },
    showStaffModal() {
      this.isStaffModal = true;
    },
    async getStaffs() {
      try {
        this.getStaffLoading = true;
        const response = await ApiService.get("user/staffs");
        this.staffs = response.data.data;
        this.getStaffLoading = false;
      } catch (error) {
        console.log(error);
        this.getStaffLoading = false;
        console.log(error.response);
      }
    },
    async getAllRoles() {
      try {
        this.getRolesLoading = true;
        const response = await ApiService.get("user/roles");
        console.log(response.data.data);
        this.getRolesLoading = false;
        this.roles = response.data.data;
        // console.log(response)
      } catch (error) {
        this.getRolesLoading = false;
        console.log(error.response);
      }
    },
    async createStaff() {
      try {
        this.creatingStaffLoading = true;
        // if (!this.staff.id) {
        //   this.staff["username"] =
        //     "ADM0000" + (parseInt(this.staffs.length) + 1);
        //   this.staffs.push(this.staff);
        // } else {
        //   const index = this.staffs.findIndex(
        //     staff => staff.id === this.staff.id
        //   );
        //   this.staffs.splice(index, 1, this.staff);
        // }
        // console.log(this.staff);
        const response = await ApiService.post("user/create-staff", this.staff);

        this.creatingStaffLoading = false;
        this.closeStaffModal();
        Swal.fire({
          title: "Success",
          text: "Staff Created",
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getStaffs();
      } catch (error) {
        this.creatingStaffLoading = false;
        this.closeStaffModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    }
  },
  mounted() {
    this.getStaffs();
    if (this.can("roles")) {
      this.getAllRoles();
    }
  }
};
</script>

<style scoped></style>
